import Button from '@mui/material/Button';
import FadeInSection from '../common/FadeInSection';
import FloraMap from '../FloraMap';
import styles from '../../styles/home/StoryTelling.module.css';

const StoryTelling = ({ onScrollClick }) => {
  return (
    <div id="homepage-section-2" className={styles.storySectionContainer}>
      <FadeInSection>
        <div className={styles.storyContentWrapper}>
          
          <h2 className={styles.sectionTitle}>
            Endangered Plants in <span>Australia</span>
          </h2>

          <div className={styles.splitLayout}>
            
            {/* --- LEFT: FRAMED MAP --- */}
            <div className={styles.mapWrapper}>
              <div className={styles.mapContainer}>
                <FloraMap />
              </div>
            </div>

            {/* --- RIGHT: INFO COLUMN (Context + Button) --- */}
            <div className={styles.infoColumn}>
              
              {/* Context Card */}
              <div className={`${styles.themeCard} ${styles.contextCard}`}>
                <h3 className={styles.cardHeader}>
                  <span>🌍</span> Disappearing Species
                </h3>
                <p className={styles.cardText}>
                  These species are fighting to survive due to rising temperatures, 
                  shifting rainfall, and human impact. 
                  <br/><br/>
                  <strong>Small actions grow into big change.</strong> Interact with 
                  the map to explore these species now to understand which regions are most critically affected.
                </p>
              </div>

              {/* CTA Button */}
              <div className={styles.ctaContainer}>
                <Button 
                  variant="contained"
                  onClick={() => onScrollClick && onScrollClick('homepage-instruction-section')}
                  sx={{
                    background: 'linear-gradient(45deg, #D68C21 30%, #E7A74E 90%)',
                    color: '#fff',
                    padding: '16px 40px',
                    fontSize: '1.1rem',
                    borderRadius: '50px',
                    fontFamily: '"Lato", sans-serif',
                    textTransform: 'none',
                    fontWeight: 700,
                    boxShadow: '0 8px 20px rgba(214, 140, 33, 0.3)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: 'linear-gradient(45deg, #C27B15 30%, #D68C21 90%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 12px 25px rgba(214, 140, 33, 0.45)',
                    }
                  }}
                >
                  See how your plants can help
                </Button>
              </div>

            </div>
          </div>

        </div>
      </FadeInSection>
    </div>
  );
};

export default StoryTelling;